
    import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
    import { InputValidationRule } from 'vuetify';
    import { mapState } from 'vuex';

    @Component({
        computed: {
            ...mapState('globals', ['formatDate', 'parseDate']),
        },
    })
    export default class DatePickerInput extends Vue {
        @Model('change', { type: String }) public value!: string | null;
        @Prop({ default: () => 'Datum' }) public label!: string;
        @Prop({ default: () => false }) public disabled!: string;
        @Prop({ default: () => [] }) public rules!: InputValidationRule[];

        public formatDate!: (input: string | null) => string | null;
        public parseDate!: (input: string | null) => string | null;

        public menu = false;
        public date: string | null = '';
        public dateFormatted: string | null = '';
        public errorMessages: string[] = [];

        public mounted(): void {
            this.onChangeValue(this.value);
        }

        @Watch('value')
        public onChangeValue(value: string | null): void {
            this.date = (value ?? '').split(' ')[0] ?? '';

            this.$nextTick(() => {
                this.dateFormatted = this.formatDate(this.date);
            });
        }

        @Watch('date')
        public onChangeDate(date: string | null): void {
            this.$nextTick(() => {
                this.dateFormatted = this.formatDate(this.date);
            });

            this.$emit('change', date);

            if (date) {
                this.validate();
            }
        }

        public validate(): boolean {
            this.resetValidation();

            for (const rule of this.rules) {
                const valid = rule(this.date);
                if (valid !== true) {
                    this.errorMessages.push(valid as string);
                }
            }

            return this.errorMessages.length === 0;
        }

        public resetValidation(): void {
            this.errorMessages = [];
        }
    }
